import { useEffect, useState } from "react";

// Tiny fade-ticker used inside both journey cards (paired contrast)
export default function JourneyTicker({ items, tone }) {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((v) => (v + 1) % items.length), 3400);
    return () => clearInterval(id);
  }, [items.length]);

  const isDark = tone === "dark";
  const labelClass = isDark ? "text-cvc-cream/55" : "text-cvc-ink-soft/60";
  const lineClass = isDark ? "text-cvc-cream" : "text-cvc-navy";
  const borderClass = isDark ? "border-cvc-cream/15" : "border-cvc-border";

  return (
    <div className={`mt-5 pt-4 border-t ${borderClass}`}>
      <p className={`text-[9px] tracking-[0.3em] uppercase font-body font-semibold ${labelClass}`}>
        {isDark ? "And then" : "Right now"}
      </p>
      <div className="relative h-12 mt-2 overflow-hidden">
        {items.map((item, idx) => (
          <p
            key={item}
            data-testid={`journey-ticker-${tone}-${idx}`}
            className={`absolute inset-0 font-heading italic text-[15px] leading-[1.35] ${lineClass} transition-opacity duration-[900ms] ease-in-out ${idx === i ? "opacity-100" : "opacity-0"}`}
          >
            {item}
          </p>
        ))}
      </div>
    </div>
  );
}
